export const SMS_ROUTER_BEHAVIOR_DEFAULT = 1
export const SMS_ROUTER_BEHAVIOR_MODE_ALOAI = 2
